/**
 * PMGW Custom JavaScript
 * Custom scripts for Nebulite theme modifications
 */

(function() {
  'use strict';
  
  /**
   * Fix accordion grouping for auto-generated product accordions
   * Moves all product-info accordions into the correct accordion-group
   */
  function fixAccordionGrouping() {
    // Find the first accordion-group (this should contain our accordions)
    const accordionGroup = document.querySelector('.product-info__block-group.accordion-group');
    if (!accordionGroup) {
      console.log('PMGW: No accordion-group found');
      return;
    }
    
    console.log('PMGW: Found accordion-group:', accordionGroup);
    
    // Find ALL accordions with class 'accordion' in the product info area
    // Try multiple selectors to catch all variations
    const selectors = [
      '.product-info__accordion.accordion',
      '.accordion.product-info__accordion',
      'details.accordion[data-accordion-title]'
    ];
    
    const allAccordions = [];
    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(acc) {
        if (!allAccordions.includes(acc)) {
          allAccordions.push(acc);
        }
      });
    });
    
    console.log('PMGW: Found', allAccordions.length, 'accordions to check');
    
    allAccordions.forEach(function(accordion) {
      // Check if this accordion is NOT a direct child of accordion-group
      if (accordion.parentElement !== accordionGroup && 
          !accordion.closest('.product-info__block-group.accordion-group')) {
        console.log('PMGW: Moving accordion to group:', accordion.getAttribute('data-accordion-title'));
        // Move it into the accordion-group
        accordionGroup.appendChild(accordion);
      }
    });
    
    // Fix the border-top for consecutive accordions
    const groupAccordions = accordionGroup.querySelectorAll('.accordion');
    console.log('PMGW: Final group has', groupAccordions.length, 'accordions');
    
    groupAccordions.forEach(function(acc, index) {
      if (index > 0) {
        acc.style.borderBlockStartWidth = '0';
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAccordionGrouping);
  } else {
    fixAccordionGrouping();
  }
  
  // Also run after a short delay to catch any late rendering
  setTimeout(fixAccordionGrouping, 100);
})();

